
import { Injectable } from "@angular/core";
import { Http, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';
import { PermissionDetails } from "./permission-details";
import { ApiResponse } from "../../models/api-response"

@Injectable()
export class AccessManagementService {
    constructor(private http: AdalHttp) {
    }

    getPermissionDetails(entity: string, entityId: string, permissionType: string,
        permissionTypeIdentifier: string): Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/${permissionType}permissions/${permissionTypeIdentifier}`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    savePermissionDetails(entity: string, entityId: string, permissionType: string,
        permissionTypeIdentifier: string, permissionDetails: Array<PermissionDetails>): Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/${permissionType}permissions/${permissionTypeIdentifier}`;
        return this.http.post(url, permissionDetails)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }


    getForgeRockPermissionDetails(entity: string, entityId: string, permissionType: string,
        permissionTypeIdentifier: string): Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/${permissionType}permissions/${permissionTypeIdentifier}/forgerock`;

        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    saveForgeRockPermissionDetails(entity: string, entityId: string, permissionType: string,
        permissionTypeIdentifier: string, permissionDetails: Array<PermissionDetails>): Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/${permissionType}permissions/${permissionTypeIdentifier}/forgerock`;
        return this.http.post(url, permissionDetails)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    addTagPermission(entity: string,entityId: string ,projectName: string, permissionDetails: Array<PermissionDetails>) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/FinedGrainAuthGrantTagPermission/${projectName}`;
        return this.http.post(url, permissionDetails)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    checkTagPermission(entity: string,entityId: string ,projectName: string, activityName: string) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/projects/${projectName}/activities/${activityName}`;
        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    deleteTagPermission(entity: string,entityId: string ,projectName: string, permissionDetails: Array<PermissionDetails>) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/FinedGrainAuthDeleteTagPermission/${projectName}`;
        return this.http.delete(url, new RequestOptions({
            body: permissionDetails
         }))
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    addGlobalPermission(entity: string,entityId: string ,projectName: string, permissionDetails: Array<PermissionDetails>) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/FinedGrainAuthGrantGlobalPermission/${projectName}`;
        return this.http.post(url, permissionDetails)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    checkGlobalPermission(entity: string,entityId: string ,projectName: string, activityName: string) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/projects/${projectName}/globalactivities/${activityName}`;
        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    deleteGlobalPermission(entity: string,entityId: string ,projectName: string, permissionDetails: Array<PermissionDetails>) : Observable<any> {
        var url = `/api/auth/${entity}s/${entityId}/FinedGrainAuthDeleteGlobalPermission/${projectName}`;
        return this.http.delete(url, new RequestOptions({
            body: permissionDetails
         }))
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/accessManagement/access-management.service.ts
 **/